import React from 'react';
import PropTypes from 'prop-types';
import CwLabel from '../cwlabel/CwLabel';
import css from './DayPicker.scss';
import cx from 'classnames';

/**
 * Lays out the label for each day of the week as a single table row with 7 td elements
 */
const WeekDays = (props) => {
  const days =  props.daysOfTheWeek;
  const result = days.map((item) =>
      <td className={cx(css.weekDays)} key={item}><CwLabel>{item}</CwLabel></td>
    );
  return(
        <tr>{result}</tr>
  );
};

WeekDays.propTypes = {
  /**
   * An array of localized days of the week
   */
  daysOfTheWeek: PropTypes.array,
};

WeekDays.defaultProps = {
  daysOfTheWeek: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
};

export default WeekDays;


// WEBPACK FOOTER //
// ./src/components/cwdatepicker/WeekDays.jsx